"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcSuggestInvoiceOption = exports.UcInvoiceTypeBadgeAlt = exports.UcInvoiceTypeBadge = exports.UcInvoiceStatusBadge = exports.UcInvoiceMiniCard = exports.UcInvoiceKindBadge = exports.UcInvoiceBadge = void 0;
const UcInvoiceBadge_yaml_component_1 = __importDefault(require("./UcInvoiceBadge.yaml?component"));
exports.UcInvoiceBadge = UcInvoiceBadge_yaml_component_1.default;
const UcInvoiceKindBadge_yaml_component_1 = __importDefault(require("./UcInvoiceKindBadge.yaml?component"));
exports.UcInvoiceKindBadge = UcInvoiceKindBadge_yaml_component_1.default;
const UcInvoiceMiniCard_yaml_component_1 = __importDefault(require("./UcInvoiceMiniCard.yaml?component"));
exports.UcInvoiceMiniCard = UcInvoiceMiniCard_yaml_component_1.default;
const UcInvoiceStatusBadge_yaml_component_1 = __importDefault(require("./UcInvoiceStatusBadge.yaml?component"));
exports.UcInvoiceStatusBadge = UcInvoiceStatusBadge_yaml_component_1.default;
const UcInvoiceTypeBadge_yaml_component_1 = __importDefault(require("./UcInvoiceTypeBadge.yaml?component"));
exports.UcInvoiceTypeBadge = UcInvoiceTypeBadge_yaml_component_1.default;
const UcInvoiceTypeBadgeAlt_yaml_component_1 = __importDefault(require("./UcInvoiceTypeBadgeAlt.yaml?component"));
exports.UcInvoiceTypeBadgeAlt = UcInvoiceTypeBadgeAlt_yaml_component_1.default;
const UcSuggestInvoiceOption_yaml_component_1 = __importDefault(require("./UcSuggestInvoiceOption.yaml?component"));
exports.UcSuggestInvoiceOption = UcSuggestInvoiceOption_yaml_component_1.default;
